<script>
  import * as _ from "lodash";
  import ProductLineSearch from "@retailer/svelte/ListBuilder/Components/ProductLineSearch.svelte";
  import ProductPicker from "@retailer/svelte/ListBuilder/Components/ProductPicker.svelte";
  import NewProduct from "@retailer/svelte/ListBuilder/Components/NewProduct.svelte";
  import Spinner from "@shared/svelte/Components/Spinner.svelte";

  export let list;
  export let placeholderProduct;
  export let isVisible;
  export let isMakingApiCall;
  export let search = {};
  export let productPicker;
  export let newProduct;
  export let onProductLineSearch;
  export let onChooseProductSize;
  export let onAddProductLinePlaceholder;
  export let onRemoveProductLinePlaceholder;
  export let onGoBackToProductLineResults;
  export let onAddProductToList;
  export let onRemoveProductFromList;
  export let onProductPickerTabChange;
  export let onAddAnotherProduct;
  export let onCreateNamedPlaceholder;
  let currentScreen;

  function getCurrentScreen() {
    if (newProduct != null) {
      return "NewProduct";
    }
    if (productPicker != null) {
      return "ProductPicker";
    }
    return "ProductLineSearch";
  }

  function needsDistributor() {
    let pl = (productPicker || {}).productLine || {};
    if (pl.distributor_id === null) {
      return true;
    }
    let did =
      pl.distributor_id ||
      (pl.distributor || {}).id ||
      (pl.distributor_info || {}).distributor_id ||
      ((pl.distributors || [])[0] || {}).id;
    return !did;
  }

  function productLineId() {
    return ((productPicker || {}).productLine || {}).id;
  }

  function onSearch(query) {
    let distributorId = _.get(placeholderProduct, "named_placeholder.distributor.id");
    onProductLineSearch(query, distributorId);
  }

  $: {
    productPicker = productPicker;
    list = list;
    currentScreen = getCurrentScreen();
  }
</script>

<div>
  {#if isMakingApiCall}
    <Spinner />
  {/if}
  {#if currentScreen === "ProductLineSearch"}
    <ProductLineSearch
      query={search.query}
      results={search.results}
      {list}
      {isVisible}
      {onSearch}
      onChooseSize={onChooseProductSize}
      onAddToListChooseSizeLater={onAddProductLinePlaceholder}
      {onRemoveProductLinePlaceholder}
    />
  {/if}
  {#if currentScreen === "ProductPicker" && !needsDistributor()}
    <ProductPicker
      picker={productPicker}
      {list}
      {placeholderProduct}
      showBackButton={search.query != null}
      {onGoBackToProductLineResults}
      {onAddProductToList}
      {onRemoveProductFromList}
      {onProductPickerTabChange}
      {onAddAnotherProduct}
    />
  {/if}
  {#if currentScreen === "ProductPicker" && needsDistributor()}
    <div class="align-center padding--medium">
      <div
        class="search__distributor-choice-alert padding--medium align-center secondary-subheader--regular secondary-headline--regular--md"
      >
        Please choose a distributor from the product page before adding to your list.
      </div>
      <a class="button button--primary margin-top--small" href={`/products/${productLineId()}`}>
        Go To Product Page
      </a>
    </div>
  {/if}
  {#if currentScreen === "NewProduct"}
    <NewProduct {...newProduct} {onCreateNamedPlaceholder} />
  {/if}
</div>
